module.exports = __webpack_public_path__ + "static/media/LS.7844c654.png";